import { AlpineComponent } from '@alpinejs/csp';

const Footer = (): AlpineComponent => ({
  height: 0,
  largerThanViewport: false,

  init() {
    this.handleResize();
  },

  handleResize() {
    const { height } = this.$refs.wrapper.getBoundingClientRect();
    this.largerThanViewport = height > window.innerHeight;

    if (this.largerThanViewport) return;
    this.$root.setAttribute('style', `--footer-height: ${height}px;`);
  },
  getClassName() {
    return { 'footer--larger-than-viewport': this.largerThanViewport };
  }
});

export default Footer;
